import { NgModule } from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';
import { Router, RouterModule } from '@angular/router';
import { SidebarComponent } from './sidebar.component';
//import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { APIS } from '../services/api';
import { NgxSpinnerModule } from 'ngx-spinner';

@NgModule({
    imports: [RouterModule, CommonModule, NgxSpinnerModule ],
    declarations: [ SidebarComponent ],
    exports: [ SidebarComponent ],
    providers:[APIS,DatePipe]
})

export class SidebarModule {
    
}
